import React from 'react';

const NumericInput = ({ value, onChange, placeholder, className, id }) => {
  const handleChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '');

    // Update immediately so React preserves focus during multi-digit entry.
    onChange(numericValue);
  };

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      value={value ?? ''}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      autoComplete="off"
    />
  );
};

NumericInput.displayName = 'NumericInput';

export default NumericInput;
